import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';

import {goToPage, reportAnalytics, setFlowType, reportFbqAnalytics, resetBlock} from '../saleBlockSlice';
import SaleWelcome from '../SaleWelcome/SaleWelcome';
import AppSaleWelcome from '../AppSaleWelcome/AppSaleWelcome';

const WelcomePage = (props) => {
  let saleType = props.saleType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'visibility_2', eventLabel: 'screen_2'});
        props.reportFbqAnalytics({event: 'TV_step1', data: {data: ''}});
        break;
      case 'app':
        props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'visibility_26', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'visibility_1', eventLabel: 'screen_1'});
        props.reportFbqAnalytics({event: 'Cellular_step1', data: {data: ''}});

        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_15', eventLabel: eventLabel});
        props.reportFbqAnalytics({event: 'Fiber_step1', data: {data: ''}});
        break;
    }
  }, []);

  //page params
  let isDisplayFooter = false;
  let btnText = '';
  let currentPageFunction = null;
  let totalPrice = props.totalPrice;
  let priceText = 'לחודש';
  let formid = 'sale';

  let currentPageHeadline = null;
  let currentPageView = null;
  //page params

  let title = '';
  let subTitle = '';

  switch (saleType) {
    case 'tv':
      title = 'לפני שנתחיל, אולי אנחנו מכירים?';
      subTitle = (
        <>
          {' '}
          אם אתם כבר לקוחות {window.Config.brand_Name_HE}, זה יהיה מהיר במיוחד <br /> וגם אם לא, נדאג שזה יהיה זריז וקל{' '}
        </>
      );
      currentPageView = (
        <SaleWelcome existsCustomerClick={handleWelcomePageClick_existsCustomer} newCustomerClick={handleWelcomePageClick_newCustomer} />
      );
      break;
    case 'app':
      title = 'מצטרפים ומיד מתחילים';
      subTitle = (
        <>
          מתקינים את האפליקציה בקלות ובמהירות
          <br />
          ונהנים ממגוון סרטים, סדרות וערוצים
        </>
      );
      currentPageView = <AppSaleWelcome />;
      currentPageFunction = handleAppSaleWelcomeContinue;
      isDisplayFooter = true;
      btnText = 'המשך';
      break;
    case 'cellular':
      title = 'לפני שנתחיל, אולי אנחנו מכירים?';
      subTitle = (
        <>
          {' '}
          אם אתם כבר לקוחות {window.Config.brand_Name_HE}, זה יהיה מהיר במיוחד <br /> וגם אם לא, נדאג שזה יהיה זריז וקל{' '}
        </>
      );
      currentPageView = (
        <SaleWelcome existsCustomerClick={handleWelcomePageClick_existsCustomer} newCustomerClick={handleWelcomePageClick_newCustomer} />
      );
      break;
    case 'internet':
      title = 'מעולה, יש לכם תשתית סיבים מוכנה בבניין!';
      subTitle = (
        <>
          {' '}
          אם אתם כבר לקוחות {window.Config.brand_Name_HE}, זה יהיה מהיר במיוחד <br /> וגם אם לא, נדאג שזה יהיה זריז וקל{' '}
        </>
      );
      currentPageView = (
        <SaleWelcome existsCustomerClick={handleWelcomePageClick_existsCustomer} newCustomerClick={handleWelcomePageClick_newCustomer} />
      );
      break;
  }

  currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-title-small'> {subTitle} </h2>
    </div>
  );

  function handleWelcomePageClick_existsCustomer() {
    props.setFlowType({flowType: 'existsCustomer'});

    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.goToPage({page: 'loginPage', percent: 11});
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'click_2', eventLabel: 'old_user'});
        break;
      case 'cellular':
        props.goToPage({page: 'loginPage', percent: 14});
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_2', eventLabel: 'old_user'});
        break;
      case 'internet':
        props.goToPage({page: 'loginPage', percent: 24});
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_19', eventLabel: eventLabel});
        break;
    }
  }

  function handleWelcomePageClick_newCustomer() {
    props.setFlowType({flowType: 'newCustomer'});

    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.goToPage({page: 'productsPage', percent: 9});
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'click_2', eventLabel: 'new_user'});
        break;
      case 'cellular':
        props.goToPage({page: 'chooseNumberPage', percent: 10});
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_2', eventLabel: 'new_user'});
        break;
      case 'internet':
        props.goToPage({page: 'otpVerifyPhone', percent: 20});
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_20', eventLabel: eventLabel});
        break;
    }
  }

  function handleAppSaleWelcomeContinue() {
    props.goToPage({page: 'extraPage', percent: 14});

    const eventLabel = props.productsInfo.selectedProducts[0]?.name;
    props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'click_37', eventLabel: eventLabel});
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className={'sale-page-content'}>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    productsInfo: state.saleBlock.productsInfo,
    isFamilyPackage: state?.saleBlock?.isFamilyPackage,
    isBack: state?.saleBlock?.isBack,
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  reportFbqAnalytics,
  setFlowType,
  resetBlock,
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage);
